import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SET_CURRENT_VEHICLE_FAVORITED } from '@/vdp/VehicleDetailsContainer/actionTypes';
import { useFavorites } from '~/context/common/UserContext';
import useGetFavoritesCommon from '~/hooks/common/favorites/useGetFavorites';
import { getVehicleId } from '~/selectors';
import useSelector from '~/store/useSelector';

export default function useGetFavorites() {
  const dispatch = useDispatch();
  const favorites = useFavorites();
  const currentVehicleId = useSelector(getVehicleId);

  const currentVehicle = favorites.find(
    vehicle => vehicle.vehicleId === currentVehicleId
  );

  useGetFavoritesCommon();

  useEffect(() => {
    dispatch({
      type: SET_CURRENT_VEHICLE_FAVORITED,
      payload: {
        isFavorited: Boolean(currentVehicle),
        isSubscribedToNotifications:
          currentVehicle?.subscribeToWIPNotifications ?? false
      }
    });
  }, [currentVehicle, dispatch]);
}
